<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div>
                            <button @click="handleModal('addTeamMemberModal')" class="btn btn-primary btn-sm mt-2 mb-4">
                                <i class="mdi mdi-plus mr-1"></i>Add Team Member
                            </button>
                        </div>
                        <UserAdminTable @handleModal="handleModal" />
                    </div>
                </div>
            </div>
        </div>

        <AddTeamMemberModal v-if="showModal_addTeamMemberModal" @handleModal="handleModal" />
        <EditTeamMemberModal v-if="showModal_editTeamMemberModal" @handleModal="handleModal" />
    </div>
</template>

<script>
import UserAdminTable from "./tables/userAdminTable.vue";
import AddTeamMemberModal from "./modals/addTeamMemberModal.vue";
import EditTeamMemberModal from "./modals/editTeamMemberModal.vue";
import { userAdministrationComputed, userAdministrationMethods } from "../../state/helpers";

export default {
    //eslint-disable-next-line
    components: { UserAdminTable, AddTeamMemberModal, EditTeamMemberModal },
    data: () => ({ showModal_addTeamMemberModal: false, showModal_editTeamMemberModal: false }),
    computed: {
        ...userAdministrationComputed,
    },
    methods: {
        ...userAdministrationMethods,
        setModalFlag(modelName, flag) {
            if (modelName == "addTeamMemberModal") return (this.showModal_addTeamMemberModal = flag);
            if (modelName == "editTeamMemberModal") return (this.showModal_editTeamMemberModal = flag);
        },

        // this method handles the displaying of modals
        handleModal(modalName) {
            //eslint-disable-next-line
            console.log("goooi");
            //call the make the modals flag active
            this.setModalFlag(modalName, true);

            setTimeout(() => {
                //eslint-disable-next-line
                this.$bvModal.show(`${modalName}`);

                this.$root.$once("bv::modal::hide", (event) => {
                    if (event.type == "hide" && event.componentId == `${modalName}`) {
                        this.setModalFlag(modalName, false);
                    }
                });
            });
        },
    },
    mounted() {},
    beforeDestroy() {
        this.setSelectedUser(null);
    },
};
</script>

<style lang="scss" scoped></style>
